<template>
  <v-main class="home-padding-reset">
    <!-- HERO -->
    <v-img
      src="@/assets/images/homepage/h-heyerlein-BsWgMBfb208-unsplash.jpg"
      max-height="100vh"
      position="left center"
      class="black"
    >
      <v-container class="col-10 pa-0 ma-0-auto hero-title">
        <v-row align="center" class="white--text fill-height">
          <v-col class="col-9 col-sm-7 col-md-8 col-lg-8">
            <h1>{{ this.$t('Home').heroSentence }}</h1>
            <v-btn
              v-if="$vuetify.breakpoint.smAndDown"
              small
              rounded
              text
              class="green white--text page-button mt-4 mb-4"
              to="/about"
              @click.native="scrollToTop"
              >{{ $t('Home').heroButton }}</v-btn
            >
            <v-btn
              v-else
              large
              rounded
              text
              class="green white--text page-button mt-6 mb-6"
              to="/about"
              @click.native="scrollToTop"
              >{{ $t('Home').heroButton }}</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-img>

    <v-container class="col-10 pa-0 ma-0-auto">
      <v-row class="pt-16 pb-16">
        <!-- CARD 1 -->

        <v-col class="col-6">
          <div align="center">
            <v-img
              src="@/assets/images/homepage/josh-riemer-flRN6KYpl1A-unsplash.jpg"
              width="500"
              height="400"
            >
            </v-img>
          </div>
        </v-col>
        <v-col class="col-6">
          <div style="margin-left: -100px; margin-top: 100px;" align="left">
            <h1 class="cta-title mb-2 pa-4 mb-sm-1 pa-sm-2">
              {{ this.$t('Home').cta1title }}
            </h1>
            <p class="cta-description mb-2 pa-4 mb-sm-2 pa-sm-2">
              {{ this.$t('Home').cta1content }}
            </p>
            <v-btn
              v-if="$vuetify.breakpoint.smAndDown"
              elevation="24"
              small
              text
              rounded
              class="green white--text page-button mb-0 mt-4"
              to="/academics/spinoff-list/"
              @click.native="scrollToTop"
            >
              {{ $t('Home').heroButton }}
            </v-btn>
            <v-btn
              v-else
              elevation="24"
              large
              text
              rounded
              class="green white--text page-button mb-0 mt-4"
              to="/academics/spinoff-list/"
              @click.native="scrollToTop"
              >{{ $t('Home').heroButton }}</v-btn
            >
          </div>
        </v-col>

        <!-- CARD 2 -->

        <v-col class="col-6">
          <div
            style="margin-right: -100px; margin-top: 100px; position: relative;
    z-index: 1;"
            align="right"
          >
            <h1 class="cta-title mb-2 pa-4 mb-sm-1 pa-sm-2">
              {{ this.$t('Home').cta2title }}
            </h1>
            <p class="cta-description mb-2 pa-4 mb-sm-2 pa-sm-2">
              {{ this.$t('Home').cta2content }}
            </p>
            <v-btn
              v-if="$vuetify.breakpoint.smAndDown"
              elevation="24"
              small
              text
              rounded
              class="green white--text page-button mb-0 mt-4"
              to="/academics/spinoff-list/"
              @click.native="scrollToTop"
            >
              {{ $t('Home').heroButton }}
            </v-btn>
            <v-btn
              v-else
              elevation="24"
              large
              text
              rounded
              class="green white--text page-button mb-0 mt-4"
              to="/academics/spinoff-list/"
              @click.native="scrollToTop"
              >{{ $t('Home').heroButton }}</v-btn
            >
          </div>
        </v-col>
        <v-col class="col-6">
          <div
            align="center"
            style="position: relative;
    z-index: 0;"
          >
            <v-img
              style=""
              src="@/assets/images/homepage/riccardo-annandale-7e2pe9wjL9M-unsplash.jpg"
              width="500"
              height="400"
            >
            </v-img>
          </div>
        </v-col>

        <!-- CARD 3 -->

        <v-col class="col-6">
          <div align="center">
            <v-img
              src="@/assets/images/homepage/pexels-markus-spiske-3970330.jpg"
              width="500"
              height="400"
            >
            </v-img>
          </div>
        </v-col>
        <v-col class="col-6">
          <div style="margin-left: -100px; margin-top: 100px;" align="left">
            <h1 class="cta-title mb-2 pa-4 mb-sm-1 pa-sm-2">
              {{ this.$t('Home').cta3title }}
            </h1>
            <p class="cta-description mb-2 pa-4 mb-sm-2 pa-sm-2">
              {{ this.$t('Home').cta3content }}
            </p>
            <v-btn
              v-if="$vuetify.breakpoint.smAndDown"
              elevation="24"
              small
              text
              rounded
              class="green white--text page-button mb-0 mt-4"
              to="/academics/spinoff-list/"
              @click.native="scrollToTop"
            >
              {{ $t('Home').heroButton }}
            </v-btn>
            <v-btn
              v-else
              elevation="24"
              large
              text
              rounded
              class="green white--text page-button mb-0 mt-4"
              to="/academics/spinoff-list/"
              @click.native="scrollToTop"
              >{{ $t('Home').heroButton }}</v-btn
            >
          </div>
        </v-col>

        <!-- CARD 4 -->

        <v-col class="col-6">
          <div
            style="margin-right: -100px; margin-top: 100px; position: relative;
    z-index: 1;"
            align="right"
          >
            <h1 class="cta-title mb-2 pa-4 mb-sm-1 pa-sm-2">
              {{ this.$t('Home').cta4title }}
            </h1>
            <p class="cta-description mb-2 pa-4 mb-sm-2 pa-sm-2">
              {{ this.$t('Home').cta4content }}
            </p>
            <v-btn
              v-if="$vuetify.breakpoint.smAndDown"
              elevation="24"
              small
              text
              rounded
              class="green white--text page-button mb-0 mt-4"
              to="/academics/spinoff-list/"
              @click.native="scrollToTop"
            >
              {{ $t('Home').heroButton }}
            </v-btn>
            <v-btn
              v-else
              elevation="24"
              large
              text
              rounded
              class="green white--text page-button mb-0 mt-4"
              to="/academics/spinoff-list/"
              @click.native="scrollToTop"
              >{{ $t('Home').heroButton }}</v-btn
            >
          </div>
        </v-col>
        <v-col class="col-6">
          <div
            align="center"
            style="position: relative;
    z-index: 0;"
          >
            <v-img
              style=""
              src="@/assets/images/homepage/photo-1527525443983-6e60c75fff46.jpeg"
              width="500"
              height="400"
            >
            </v-img>
          </div>
        </v-col>

        <!-- 
        <v-col class="col-12 col-xs-12 col-sm-6 col-md-6 col-lg-6 pa-16">
          <v-card elevation="6" align="center">
            <v-img
              src="@/assets/images/homepage/josh-riemer-flRN6KYpl1A-unsplash.jpg"
              height="400"
            >
              <div class="pa-16 pa-xs-16 pa-sm-10 pa-md-10 pa-lg-16">
                <h1 class="cta-title mb-2 pa-4 mb-sm-1 pa-sm-2">
                  {{ this.$t('Home').cta1title }}
                </h1>
                <p class="cta-description mb-2 pa-4 mb-sm-2 pa-sm-2">
                  {{ this.$t('Home').cta1content }}
                </p>
                <v-btn
                  elevation="24"
                  large
                  text
                  rounded
                  class="green white--text page-button mt-6"
                  to="/academics/spinoff-list/"
                  @click.native="scrollToTop"
                >
                  {{ $t('Home').heroButton }}
                </v-btn>
              </div>
            </v-img></v-card
          ></v-col
        >

        <v-col class="col-12 col-xs-12 col-sm-6 col-md-6 col-lg-6 pa-16">
          <v-card elevation="6" align="center">
            <v-img
              src="@/assets/images/homepage/riccardo-annandale-7e2pe9wjL9M-unsplash.jpg"
              height="400"
            >
              <div class="pa-16 pa-xs-16 pa-sm-10 pa-md-10 pa-lg-16">
                <h1 class="cta-title mb-2 pa-4 mb-sm-1 pa-sm-2">
                  {{ this.$t('Home').cta2title }}
                </h1>
                <p class="cta-description mb-2 pa-4 mb-sm-2 pa-sm-2">
                  {{ this.$t('Home').cta2content }}
                </p>
                <v-btn
                  elevation="8"
                  large
                  text
                  rounded
                  class="green white--text page-button mt-6"
                  to="/academics/disclose-protect-your-ip"
                  @click.native="scrollToTop"
                >
                  {{ $t('Home').heroButton }}
                </v-btn>
              </div>
            </v-img></v-card
          ></v-col
        >

        <v-col class="col-12 col-xs-12 col-sm-6 col-md-6 col-lg-6 pa-16">
          <v-card elevation="6" align="center">
            <v-img
              src="@/assets/images/homepage/pexels-markus-spiske-3970330.jpg"
              height="400"
            >
              <div class="pa-16 pa-xs-16 pa-sm-10 pa-md-10 pa-lg-16">
                <h1 class="cta-title mb-2 pa-4 mb-sm-1 pa-sm-2">
                  {{ this.$t('Home').cta3title }}
                </h1>
                <p class="cta-description mb-2 pa-4 mb-sm-2 pa-sm-2">
                  {{ this.$t('Home').cta3content }}
                </p>
                <v-btn
                  elevation="8"
                  large
                  rounded
                  text
                  class="green white--text page-button mt-6"
                  to="/technologies/"
                  @click.native="scrollToTop"
                >
                  {{ $t('Home').heroButton }}
                </v-btn>
              </div>
            </v-img></v-card
          ></v-col
        >

        <v-col class="col-12 col-xs-12 col-sm-6 col-md-6 col-lg-6 pa-16">
          <div>
            <v-card elevation="6" align="center">
              <v-img
                src="@/assets/images/homepage/photo-1527525443983-6e60c75fff46.jpeg"
                height="400"
              >
                <div class="pa-16 pa-xs-16 pa-sm-10 pa-md-10 pa-lg-16">
                  <h1 class="cta-title mb-2 pa-4 mb-sm-1 pa-sm-2">
                    {{ this.$t('Home').cta4title }}
                  </h1>
                  <p class="cta-description mb-2 pa-4 mb-sm-2 pa-sm-2">
                    {{ this.$t('Home').cta4content }}
                  </p>

                  <v-btn
                    large
                    rounded
                    text
                    class="green white--text page-button mt-6"
                    to="/industry/collab/"
                    @click.native="scrollToTop"
                  >
                    {{ $t('Home').heroButton }}
                  </v-btn>
                </div>
              </v-img></v-card
            >
          </div></v-col
        > -->
      </v-row>
    </v-container>

    <LatestNews />
  </v-main>
</template>

<script>
import LatestNews from '@/views/LatestNews'

export default {
  name: 'Home',
  components: { LatestNews },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0)
    },
  },
}
</script>

<style lang="scss" scoped>
.home-padding-reset {
  padding: 0px !important;
}

// HERO
.hero-title {
  margin-top: 18%;

  h1 {
    font-family: $heading-font-family;
    font-weight: 900;
    letter-spacing: 0.1rem;
    font-size: 3.5rem;
    text-transform: uppercase;
    overflow-wrap: normal;
  }
}

// CTA

.cta-title {
  color: black;
  background: white;
  opacity: 0.9;
  font-family: $heading-font-family;
  font-weight: bold;
  font-size: 20px;
  text-transform: uppercase;
  word-break: break-word;
  hyphens: auto;
}

.cta-description {
  color: black;
  background: white;
  opacity: 0.9;
  font-family: $body-font-family;
  font-weight: normal;
  font-size: 16px;
}

@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .hero-title {
    margin-top: 26%;

    h1 {
      font-size: 17px;
    }
  }
  .cta-title {
    font-size: 16px;
  }
  .cta-description {
    font-size: 14px;
  }
}

@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .page-button {
    font-size: 10px;
  }
}
</style>
